const mediaItems = [
  {
    title: '七月新番速递 — 这些日漫不容错过',
    desc: '整理本季最值得追的日漫新番，从热血战斗到治愈日常，51动漫官网已全部上线，免费在线观看与下载。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20illustration%20of%20various%20Japanese%20animation%20characters%20in%20action%20poses%20with%20warm%20cinematic%20lighting%20orange%20and%20gold%20accents%20soft%20gradient%20background%20modern%20composition%20clean%20aesthetic&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    title: '国漫崛起 — 2026 上半年必看口碑作',
    desc: '国漫精品合集推荐，涵盖仙侠、玄幻、都市等热门类型。51动漫官网国漫频道每日更新，支持高清流畅播放。',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20animation%20style%20scene%20with%20flowing%20robes%20and%20ancient%20architecture%20warm%20amber%20and%20coral%20color%20palette%20dreamlike%20atmosphere%20soft%20lighting%20cinematic%20composition%20clean%20background&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    title: '韩漫精选 — 这些热门作品正在连载中',
    desc: '下拉式阅读完美适配韩漫长条画风，51动漫官网收录热门韩漫连载资源，支持免费下拉式连续追更。',
    img: 'https://readdy.ai/api/search-image?query=Stylish%20Korean%20webtoon%20style%20illustration%20with%20modern%20romance%20vibe%20warm%20coral%20and%20soft%20peach%20color%20palette%20vertical%20scrolling%20aesthetic%20clean%20composition%20soft%20natural%20lighting%20elegant%20atmosphere&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          精彩推荐
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100/80 rounded-xl overflow-hidden hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}